// src/constants/analyticsProducts.js
//
// Mapping between TopNav mode ids and analytics product codes.
// Mode ids are local to the frontend's routing system. Product codes
// are the backend's stable identifier in aiprime.analytics_products.
//
// Modes not in this map are non-analytics (explore, purchase) and
// don't require analytics entitlement checks.

export const MODE_TO_PRODUCT = {
  well_finder: "WELLFINDER",
  siteid: "ASSETID",
  padrekko: "PADREKKO",
  helios: "AOID",  // AI On-Demand (the jobs surface). Gated like the others.
};

export const PRODUCT_TO_MODE = Object.fromEntries(
  Object.entries(MODE_TO_PRODUCT).map(([k, v]) => [v, k])
);

// Modes that don't require entitlement checks — always available.
export const UNGATED_MODES = new Set(["explore", "purchase"]);

// ── THE PORTAL'S PRODUCT CODE, WHICH IS NOT A MODE ─────────────────────────
//
// It is not in MODE_TO_PRODUCT because it is not a map tab: MODE_TO_PRODUCT
// keys the goMapTab() list, and /portal is a top-level route. But it IS an
// analytics product -- aiprime.analytics_products row PORTAL, migration 120 --
// so a platform admin grants it exactly the way they grant WELLFINDER, and
// TopNav filters the entry on the same entitled-codes set every other product
// in that strip is filtered on.
//
// GATES THE ENTRY POINT, NOT THE API. /api/v1/portal/* is still authorized by
// plan_review_submission_grants, the restricted-account class and RLS. The
// migration's header says why a caller-org entitlement check would be wrong
// here: a plan review has an owner org AND an operator org, and the submitter
// belongs to the operator.
export const PORTAL_PRODUCT = "PORTAL";